var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.451 3.87292C8.96975 1.75542 7.12267 0.802086 5.50017 0.802086C5.50017 0.802086 5.50017 0.802086 5.49558 0.802086C3.87767 0.802086 2.026 1.75084 1.54475 3.86834C1.0085 6.23334 2.45683 8.23625 3.76767 9.49667C4.2535 9.96417 4.87683 10.1979 5.50017 10.1979C6.1235 10.1979 6.74683 9.96417 7.22808 9.49667C8.53892 8.23625 9.98725 6.23792 9.451 3.87292ZM5.50017 6.16917C4.70267 6.16917 4.05642 5.52292 4.05642 4.72542C4.05642 3.92792 4.70267 3.28167 5.50017 3.28167C6.29767 3.28167 6.94392 3.92792 6.94392 4.72542C6.94392 5.52292 6.29767 6.16917 5.50017 6.16917Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.59d0a8d0767bc861e17f8ecaad59fecd.svg";
export { ForwardRef as ReactComponent };